import {memo, useEffect, useState} from "react";
import './Cookie.css';
import {checkActive} from "../http/orderApi";

const Cookie = memo(() => {

    const [showCookieAlert, setShowCookieAlert] = useState(true)

    useEffect(() => {
        if (localStorage.getItem('cookie-alert')) {
            setShowCookieAlert(false)
        }
    }, [])

    const closeCookie = () => {
        setShowCookieAlert(false)
        localStorage.setItem('cookie-alert', true)
    }

    return (
        <div>
            {
                showCookieAlert ?
                    <div className="cookie-alert">
                        <div className="cookie-alert-text">
                            Продолжая пользоваться нашим сайтом, вы соглашаетесь
                            с&nbsp;использованием файлов cookie и сервиса веб-аналитики Яндекс.Метрика. Подробные условия изложены в <a target="_blank" href="/personal/privacy-policy/">Политике конфиденциальности</a>
                        </div>
                        <div className="cookie-alert-close" onClick={closeCookie}>
                            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M1 1L9.04041 9.04039M9.04041 9.04039L1 17M9.04041 9.04039L17 1M9.04041 9.04039L17 17" stroke="white" strokeWidth="2" strokeLinecap="round"/>
                            </svg>
                        </div>
                        <div className="cookie-alert-button" onClick={closeCookie}>Ok</div>
                    </div> : ""
            }
        </div>
    )
})

export default Cookie;